module.exports = __webpack_public_path__ + "static/media/search.3e5fa9b7.svg";